import axios from "axios"

const auth = localStorage.getItem("auth_token");
const headers = {
    "x-auth-token": auth,
};

export const getProjectOptions = async (w_id, company_type) => {
    return new Promise((resolve, reject) => {
        axios
            .get(`api/v1/project/previous-year-data?wId=${w_id}&companyType=${company_type}`, { headers })
            .then((res) => {
                return resolve(res);
            })
            .catch((err) => {
                return reject(err);
            });
    });
};